// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MilestoneVM  {
    _originalTypeClassName = "Loom.BO.MilestoneVM";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MilestoneVM.translate = translateService;
}
this.project_acronym = null;
this.leader_shortname = null;
this.num = null;
this.title = null;
this.means_of_verification = null;
this.month_due = null;
this.wp_numbers = null;
this.MilestoneVMKey = null;
this._key = this.MilestoneVMKey = 0; 
}

static translate: TranslateService;
_key: any;
project_acronym:any;
leader_shortname:any;
num:any;
title:any;
means_of_verification:any;
month_due:any;
wp_numbers:any;
private _MilestoneVMKey:any;
get MilestoneVMKey(): any {
    return this._MilestoneVMKey;
  }
set MilestoneVMKey(value: any) {
    this._MilestoneVMKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MilestoneVMKey == null || $this.MilestoneVMKey == 0;
            }


}